export default __webpack_public_path__ + "static/media/BrijeshBurfal_Resume.1aa0b567.pdf";